export default __webpack_public_path__ + "static/media/banner.f65c36c9.svg";